import './Clients.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import { useEffect, useState } from 'react';

const CLIENT_FADE_COUNT = 10;

export default function Clients() {
  const [visibleCards, setVisibleCards] = useState([]);
  const [Clientele, setClientele] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/our_product_list"
        );

        // ✅ Sort alphabetically by client name
        const sortedData = response.data.data.sort((a, b) =>
          a.our_title.localeCompare(b.our_title)
        );

        setClientele(sortedData);
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });

    const timeout = setTimeout(() => {
      const indices = Array.from({ length: CLIENT_FADE_COUNT }, (_, i) => i);
      setVisibleCards(indices);
    }, 300);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="clients-grid">
      {Clientele.map((Data, index) => (
        <div
          className={`client-card ${visibleCards.includes(index) ? 'visible' : ''}`}
          key={index}
          data-aos={index >= CLIENT_FADE_COUNT ? 'fade-up' : ''}
        >
          <img
            src={`https://cyberathon.com/NLF/${Data.our_images}`}
            alt={Data.our_title}
            className='mt-1'
          />
          <p className='mb-1'><strong>{Data.our_title}</strong></p>
        </div>
      ))}
    </div>
  );
}
